import { CommonModule } from '@angular/common';
import { Component, computed, input, linkedSignal } from '@angular/core';
import { UserRolesModel } from '@module-instance/activity/common';
import { TranslateModule } from '@ngx-translate/core';

export type SeeMoreDataType = 'text' | 'userRoles';

@Component({
  selector: 'cipo-see-more',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './see-more.component.html',
})
export class SeeMoreComponent {
  text = input.required<UserRolesModel[] | string[] | string>();
  dataType = input<SeeMoreDataType>('text');
  limit = input.required<number>();
  separator = input(', ');
  customClass = input('');
  placeholder = input('-');

  isList = computed(() => Array.isArray(this.text()));
  private entireText = computed(() =>
    this.isList() ? (this.text() as string[]).join(this.separator()) : (this.text() as string),
  );
  needsTruncate = computed(() =>
    this.isList() ? this.text().length > this.limit() : (this.text() as string).split(' ').length > this.limit(),
  );
  isExpanded = linkedSignal(() => !this.needsTruncate());
  displayed = computed(() => {
    if (this.dataType() !== 'text') {
      return null;
    }
    return this.isExpanded() || !this.needsTruncate()
      ? this.entireText()
      : this.isList()
        ? (this.text() as string[]).slice(0, this.limit()).join(this.separator())
        : (this.text() as string).split(' ').slice(0, this.limit()).join(' ');
  });
  userRoles = computed(() => {
    if (this.dataType() !== 'userRoles') {
      return null;
    }
    if (!this.isExpanded() && this.needsTruncate()) {
      return (this.text() as UserRolesModel[]).slice(0, this.limit());
    }
    return this.text() as UserRolesModel[];
  });

  toggle = () => this.isExpanded.update(v => !v);
}
